import { Select } from "antd";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import timezones from "./TimeZoneList";
type CustomFormItemProps = {
  value?: string;
  onChange?: (timezone: string) => void;
};

/**
 * A component that renders a timezone selector for antd.
 * @param value initialValue passed by parent Form.Item.
 * @param onChange a callback for Form.Item to read its child component's value.
 * @constructor
 */
export const TimeZoneSelect: React.FC<CustomFormItemProps> = ({
  value,
  onChange,
}) => {
  const [selectedTimezone, setSelectedTimezone] = useState<string>();
  const { Option } = Select;

  const setdefaultzone = () => {
    const currentzone = dayjs.tz.guess();

    if (currentzone) {
      setSelectedTimezone(currentzone);
    }
  };

  useEffect(() => {
    if (value) {
      if (timezones[value]) {
        setSelectedTimezone(value);
      } else {
        setdefaultzone();
      }
    } else {
      setdefaultzone();
    }
  }, [value]);

  return (
    <Select
      showSearch
      value={selectedTimezone || ""}
      onChange={(value: string, option) => {
        if (selectedTimezone) {
          setSelectedTimezone(value);
        }
        if (typeof onChange === "function") {
          onChange(value);
        }
      }}
      filterOption={(input, option) => {
        return (option?.value?.toString().toLocaleLowerCase() ?? "").includes(
          input
        );
      }}
    >
      {Object.keys(timezones).map((timezone, index) => {
        return (
          <Option key={index} value={timezone}>
            {timezone}
          </Option>
        );
      })}
    </Select>
  );
};
